import { Outlet } from 'react-router-dom';
import MenuBar from './MenuBar';
import Header from './Header';

const BackOfficeLayout = () => (
  <div className='page'>
    <Header />
    <div className='main-content'>
      <MenuBar />
      <div className='content-area'>
        <Outlet />
      </div>  
    </div>
  </div>
);

export default BackOfficeLayout;
